import { ContactReportRole, Issue } from "generated-graphql/graphql";

export type IssueRow = {
  __issueRow: true;
  id: string;
  issue: Issue;
  requiredReportingRole: ContactReportRole;
};

/**
 * Build the "virtual" suggestion rows that prepend the Facility Contacts
 * omnisearch grid. Mirrors the V1 `<FacilityContacts>` behavior: surface every
 * `key === "contacts"` issue that flags `metadata.suggestFacilityContactAdd`
 * with a `metadata.requiredReportingRole`, but only when the viewer has
 * write permission.
 */
export function buildSuggestionRows(allIssues: Issue[], canWriteContacts: boolean): IssueRow[] {
  if (!canWriteContacts) return [];
  return allIssues.flatMap((issue) => {
    if (issue.key !== "contacts") return [];
    const requiredReportingRole = issue.metadata?.requiredReportingRole as
      | ContactReportRole
      | undefined;
    const suggestFacilityContactAdd = Boolean(issue.metadata?.suggestFacilityContactAdd);
    if (!requiredReportingRole || !suggestFacilityContactAdd) return [];
    return [
      {
        __issueRow: true as const,
        id: `issue:${issue.message}`,
        issue,
        requiredReportingRole,
      },
    ];
  });
}
